<template lang="pug">
	.relative
		.flex.flex-wrap.items-center.relative
			Avatar.mr-1(size="small" v-if="isSelected(teammate.id)" :profile="teammate" v-for="teammate in teammates")
			
			eva-icon.icon.text-gray-4.cursor-pointer.mt-2(name="edit" @click="showAddDropdown = true")
			
			.dropdown.absolute.right-0.top-0(v-if="showAddDropdown")
				.fixed.top-0.right-0.w-screen.h-screen.blur-bg-sm.z-10(@click="showAddDropdown = false")
				.relative.bg-white.p-4.shadow-xl.mt-10.rounded-lg.z-10.w-64
					p.mb-2 Teammates
					.flex.items-center.my-1.-mx-1.p-1.rounded-lg.cursor-pointer(class="hover:bg-gray-1" v-for="teammate in teammates" @click="toggleTeammate(teammate, isSelected(teammate.id))")
						Avatar.flex-shrink-0(:profile="teammate" size="small") 
						span.flex-grow.ml-2 {{teammate.displayName}}
						eva-icon.flex-shrink-0.icon.text-gray-4.cursor-pointer(name="checkmark-outline" v-if="isSelected(teammate.id)")
		
		.blur-bg-sm.whiter.absolute.top-0.right-0.bottom-0.left-0.flex.items-center.-m-1(v-if="loading")
			eva-icon.icon.spin.text-gray-6(name="loader-outline")
</template>

<script>
import { mapGetters } from "vuex";
import Avatar from "./Avatar";

export default {
  name: "Teammates",
  props: ["owners", "parentId"],
  components: { Avatar },
  data() {
    return {
      showAddDropdown: false,
      loading: false
    };
  },
  computed: {
    ...mapGetters(["company", "profile", "teammates"])
  },
  created() {},
  methods: {
    isSelected(id) {
      return this.owners.some(owner => owner == id);
    },
    toggleTeammate(teammate, isAdded) {
      if (isAdded) this.removeTeammate(teammate);
      else this.addTeammate(teammate);
    },
    addTeammate(teammate) {
      this.loading = true;

      this.$store
        .dispatch("arrayUnion", {
          collection: "keyResults",
          id: this.parentId,
          array: "owners",
          item: teammate.id
        })
        .then(() => {
          this.$store.dispatch("fireNotification", {
            title: "Assigned " + teammate.displayName + " to this goal",
            type: "success"
          });
          return this.$store.dispatch("getKeyResults", this.profile.companyId);
        })
        .then(() => {
          this.loading = false;
          this.$emit("done");
        });
    },
    removeTeammate(teammate) {
      this.loading = true;

      this.$store
        .dispatch("arrayDelete", {
          collection: "keyResults",
          id: this.parentId,
          array: "owners",
          item: teammate.id
        })
        .then(() => {
          this.$store.dispatch("fireNotification", {
            title: "Removed " + teammate.displayName + " from this goal",
            type: "success"
          });
          return this.$store.dispatch("getKeyResults", this.profile.companyId);
        })
        .then(() => {
          this.loading = false;
          this.$emit("done");
        });
    }
  },
  directives: {
    focus: {
      inserted(el) {
        el.focus();
      }
    }
  }
};
</script>

<style lang="sass" scoped>
.whiter
	background: rgba(255,255,255,0.6)
</style>
